<div (clickOutside)="closeActionMenu($event)" class="cell-menu-container">
  <div (click)="toggleMenu($event)" class="dots" id="Dots_Bulk">
    <div (click)="toggleMenu($event)" class="dots" id="HeaderRowDots">...</div>
  </div>
</div>